export const STANDARD_TEAM_LOBBY_SETTINGS = {
    durationMinutes: 3,
    spectatorsAllowed: true,
    visibility: "public",
};
/** Rakip kelimeyi bulduğunda kalan süre bu değere kadar kısalır. */
export const PRESSURE_DEADLINE_MS = 30_000;
//# sourceMappingURL=types.js.map